import format from "date-fns/format";

export default dateTime => {
    console.log(dateTime);
    console.log(dateTime > new Date('2021-01-01T00:00:00Z'))
    return dateTime > new Date('2021-01-01T00:00:00Z') ? format(dateTime, "dd-MMM-yyyy") : "Unknown";
}